import { useGoogleAccountStatus } from '../../../contexts/GoogleCalendar'

/**
 * Compact error indicator for use in menus or small spaces
 */
export function GoogleAccountErrorIndicator() {
  const { data: accountStatus } = useGoogleAccountStatus()

  if (!accountStatus?.hasErrors && !accountStatus?.hasExpired) {
    // eslint-disable-next-line unicorn/no-null -- react requires null
    return null
  }

  const errorCount = (accountStatus.error || 0) + (accountStatus.expired || 0)

  return (
    <div className='flex items-center gap-1 text-red-400 dark:text-red-300'>
      <i className='fa-solid fa-triangle-exclamation text-xs' />
      <span className='text-xs'>
        {errorCount} account{errorCount > 1 ? 's' : ''} have errors, please
        remove and re-add
      </span>
    </div>
  )
}
